{
  "privacy": {
    "consentTitle": "Privacidade e analytics",
    "consentBody": "Usamos analytics para melhorar o produto e crash reports para encontrar erros. Escolha o que deseja permitir. Você pode alterar em Conta → Privacidade.",
    "analyticsLabel": "Analytics de uso",
    "analyticsDesc": "Mixpanel/Google Analytics para métricas de produto e funil. Se recusar, contamos apenas passos do funil de forma agregada e anônima (sem identificadores, sem Mixpanel/GA).",
    "crashLabel": "Relatórios de erro",
    "crashDesc": "Sentry para erros técnicos, estabilidade e diagnóstico.",
    "acceptAll": "Aceitar tudo",
    "rejectAll": "Recusar tudo",
    "saveChoices": "Salvar escolhas",
    "settingsItemTitle": "Privacidade",
    "settingsItemDesc": "Analytics, relatórios de erro e opt-out",
    "accountSection": "Conta",
    "sectionTitle": "Consentimento de dados",
    "sectionBody": "Controle separadamente analytics de produto e relatórios de erro. Ao desligar, novas chamadas deixam de ser enviadas.",
    "savePreferences": "Salvar preferências",
    "saved": "Preferências de privacidade salvas."
  },
  "errorBoundary": {
    "title": "Algo deu errado",
    "message": "Ocorreu um erro inesperado. Já fomos notificados. Você pode tentar novamente ou entrar em contato com o suporte.",
    "retry": "Tentar novamente",
    "contactSupport": "Falar com o suporte"
  },
  "loginTitle": "Login",
  "emailPlaceholder": "Email",
  "passwordPlaceholder": "Senha",
  "loginButton": "Entrar",
  "signupPrompt": "Não tem uma conta?",
  "signupLink": "Cadastrar",
  "loginError": "Por favor, digite o email e a senha.",
  "loginFailed": "Email ou senha incorretos.",
  "loginSuccess": "Bem-vindo, {{email}}!",
  "registerChoiceTitle": "Registar",
  "chooseRolePrompt": "Escolha como deseja registar-se: Condutor ou Proprietário de Frota. Se for ambos, registe-se como Proprietário.",
  "driverButton": "Condutor",
  "ownerButton": "Proprietário de Frota",
  "registerDriverTitle": "Registo de Condutor",
  "nifPlaceholder": "NIF",
  "addressPlaceholder": "Morada",
  "licenseTypePlaceholder": "Tipo de Licença",
  "licenseNumberPlaceholder": "CMTVDE",
  "workStartDatePlaceholder": "Data de Início de Trabalho",
  "dobPlaceholder": "Data de Nascimento",
  "dateOfBirthPlaceholder": "Data de Nascimento",
  "dualRoleMessage": "Se você é tanto Proprietário quanto Condutor, registe-se como Proprietário.",
  "registerOwnerTitle": "Registar como Proprietário de Frota",
  "submitButton": "Enviar",
  "fullNamePlaceholder": "Nome Completo",
  "phoneNumberPlaceholder": "Número de Telefone",
  "companyNamePlaceholder": "Nome da Empresa",
  "companyEmailPlaceholder": "Email da Empresa",
  "nipcPlaceholder": "NIPC",
  "certidaoPermanentePlaceholder": "Certidão Permanente",
  "numeroLicencaPlaceholder": "CMTVDE",
  "registerSuccess": "Registo efetuado com sucesso!",
  "registerFailed": "O registo falhou.",
  "goBack": "Voltar",
  "userInformation": "Informação do Utilizador",
  "companyInformation": "Informação da Empresa",
  "forgotPassword": "Esqueceu sua senha?",
  "invalidEmail": "Email inválido",
  "emailVerifiedSuccessfully": "Email verificado com sucesso!",
  "invalidPassword": "Palavra-passe deve ter no mínimo 8 caracteres.",
  "requiredField": "Campo obrigatório.",
  "registrationSuccessTitle": "Registado com sucesso!",
  "registrationSuccessMessage": "Confirme o seu email para completar o registo.",
  "okButton": "OK",
  "ok": "OK",
  "manageInStripe": "Gerenciar no Stripe",
  "manageSubscription": "Gerenciar Assinatura",
  "drivingTimeToday": "Condução hoje",
  "startDriving": "Iniciar condução",
  "drivingStates": {
    "starting": "Iniciando...",
    "stopping": "Parando...",
    "endingSession": "Encerrando sessão...",
    "processing": "Processando..."
  },
  "startSession": "Iniciar Sessão",
  "close": "Fechar",
  "waitingForActivation": "Ativação pendente",
  "pendingSelfPayHint": "Não quer esperar? Você pode ativar sua própria licença agora.",
  "pendingSelfPayCta": "Eu pago a minha licença",
  "pendingEmploymentMessage": "Aguarde a empresa {{nipc}} ativar o seu perfil.",
  "addAnotherCompany": "Adicionar outra empresa",
  "addCompanyInfo": "Adicionar Informações da Empresa responsável pela frota",
  "back": "Voltar",
  "addVehicleInfo": "Adicionar Veículo",
  "registrationNumber": "Matrícula",
  "make": "Marca",
  "model": "Modelo",
  "fuelType": {
    "gasolina": "Gasolina",
    "gasoleo": "Diesel",
    "bifuel": "Bi-fuel",
    "hibrido": "Híbrido",
    "eletrico": "Elétrico"
  },
  "endSession": "Terminar Sessão",
  "stopDriving": "Parar de Conduzir",
  "selectVehicle": "Selecione um veículo",
  "errorStartingSession": "Erro ao iniciar a sessão",
  "errorEndingSession": "Erro ao terminar a sessão",
  "errorStartingDriving": "Erro ao iniciar a condução",
  "errorStoppingDriving": "Erro ao parar de conduzir",
  "odometer": "KM atual",
  "weeklyDrivingReport": "Relatórios semanais",
  "driverDetails": "Detalhes do Condutor",
  "companyDetails": "Detalhes da Empresa",
  "name": "Nome",
  "phoneNumber": "Número de Telefone",
  "dateOfBirth": "Data de Nascimento",
  "nif": "NIF",
  "address": "Morada",
  "licenseNumber": "CMTVDE",
  "companyName": "Nome da Empresa",
  "nipc": "NIPC",
  "companyEmail": "Email da Empresa",
  "totalWeek": "Total da Semana",
  "loading": {
    "default": "Carregando...",
    "checkingData": "Verificando dados...",
    "loadingVehicles": "Carregando veículos...",
    "loadingData": "Carregando dados...",
    "userInformation": "Carregando informações do usuário..."
  },
  "driverDashboard": {
    "noVehicleAssignedTitle": "Nenhum veículo atribuído",
    "noVehicleAssignedRecoveryMessage": "Você está no modo Motorista, mas ainda não tem um veículo atribuído. Pode continuar a configuração do veículo ou voltar para o perfil de Proprietário.",
    "noVehicleAssignedDriverOnlyMessage": "Sua empresa ainda não atribuiu um veículo a você. Você pode continuar a configuração agora ou voltar mais tarde.",
    "continueVehicleSetup": "Continuar configuração do veículo",
    "redirectingToVehicleSetup": "Redirecionando para a configuração do veículo..."
  },
  "noReport": "Nenhum relatório disponível",
  "notProvided": "Não fornecido",
  "noLocation": "Sem localização",
  "reports": "Relatórios",
  "nextWeek": "Semana Seguinte",
  "previousWeek": "Semana Anterior",
  "exportPDF": "Exportar PDF",
  "errorExportingPDF": "Erro ao exportar o PDF",
  "home": "Início",
  "logout": "Sair",
  "settings": "Configurações",
  "switchToDriver": "Mudar para Motorista",
  "switchToOwner": "Mudar para Proprietário",
  "receiveNotifications": "Receber Notificações",
  "stopTimeThreshold": "Tempo Parado (minutos)",
  "distanceThreshold": "Distância para Alerta (metros)",
  "save": "Salvar",
  "preferencesSaved": "Preferências guardadas!",
  "errorSavingPreferences": "Erro ao guardar preferências.",
  "sessionInactive": "Sessão inativa",
  "sessionActive": "Sessão ativa",
  "driving": "A conduzir",
  "locationExplanation": "Precisamos de acesso à localização o tempo todo para monitorizar a sua condução e enviar alertas quando necessário.",
  "foregroundLocation": "Localização em Primeiro Plano",
  "backgroundLocation": "Localização em Segundo Plano",
  "enabled": "Ativado",
  "enable": "Ativar",
  "goToSettings": "Ir para Definições",
  "permissionDenied": "Permissão Negada",
  "permissionExplanation": "Precisamos da permissão de {{type}} para monitorizar a sua localização e enviar notificações em tempo real.",
  "vehicleRegistration": "Matrícula do Veículo",
  "odometerStart": "KM Inicial",
  "odometerEnd": "KM Final",
  "drivingTime": "Tempo de Condução",
  "availabilityTime": "Tempo de Disponibilidade",
  "restTime": "Tempo de Descanso",
  "logs": "Registos",
  "observations": "Observações",
  "totalWeekDriving": "Total da Semana (Condução)",
  "totalWeekAvailability": "Total da Semana (Disponibilidade)",
  "totalWeekRest": "Total da Semana (Descanso)",
  "eventType": "Tipo de Evento",
  "start": "Início",
  "end": "Fim",
  "startLocation": "Local de Início",
  "endLocation": "Local de Fim",
  "total": "Total",
  "available": "Disponível",
  "notificationSettings": "Definições de notificações",
  "permissions": "Permissões",
  "status": "Estado",
  "cancel": "Cancelar",
  "currentWeek": "Semana Atual",
  "selectWeek": "Selecionar Semana",
  "selectedWeek": "Semana Selecionada",
  "selectDate": "Selecionar Data",
  "select": "Selecionar",
  "clickDateToSelectWeek": "Clique numa data para selecionar essa semana",
  "email": "E-Mail",
  "daily-report": "Relatório do dia",
  "dailyDrivingReport": "Relatório do dia",
  "success": "Sucesso",
  "error": "Erro",
  "resetPasswordTitle": "Redefinir Senha",
  "resetPasswordDescription": "Digite seu e-mail e enviaremos instruções para redefinir sua senha.",
  "resetPasswordButton": "Enviar Link de Redefinição",
  "changePasswordButton": "Alterar Senha",
  "resetPasswordSuccess": "Se existir uma conta com este e-mail, você receberá instruções para redefinir a senha.",
  "resetPasswordError": "Ocorreu um erro ao solicitar a redefinição de senha. Por favor, tente novamente.",
  "resetPasswordFailed": "Não foi possível enviar o e-mail de redefinição de senha.",
  "currentPasswordPlaceholder": "Senha atual",
  "newPasswordPlaceholder": "Nova Senha",
  "confirmPasswordPlaceholder": "Confirmar Nova Senha",
  "passwordsDontMatch": "As senhas não coincidem",
  "passwordResetSuccess": "Sua senha foi redefinida com sucesso. Por favor, faça login com sua nova senha.",
  "passwordChangeSuccess": "Sua senha foi alterada com sucesso.",
  "passwordResetError": "Ocorreu um erro ao redefinir sua senha. O link pode ter expirado.",
  "allFieldsRequired": "Por favor, preencha todos os campos",
  "networkError": "Erro de rede. Por favor, tente novamente.",
  "enterNewPassword": "Digite sua nova senha abaixo.",
  "emailRequired": "Por favor, digite seu endereço de e-mail",
  "passwordRequired": "A senha é obrigatória",
  "passwordTooShort": "A senha deve ter pelo menos 8 caracteres",
  "passwordMustContainUppercase": "A senha deve conter pelo menos uma letra maiúscula",
  "passwordMustContainLowercase": "A senha deve conter pelo menos uma letra minúscula",
  "passwordMustContainNumber": "A senha deve conter pelo menos um número",
  "passwordValidationError": "Erro de validação da senha",
  "fullNameRequired": "O nome completo é obrigatório",
  "phoneNumberRequired": "O número de telefone é obrigatório",
  "companyNameRequired": "O nome da empresa é obrigatório",
  "nipcRequired": "O NIPC é obrigatório",
  "nipcInvalidLength": "O NIPC deve ter 9 dígitos",
  "certidaoPermanenteRequired": "A certidão permanente é obrigatória",
  "certidaoPermanenteInvalidLength": "A certidão permanente deve ter 12 caracteres",
  "numeroLicencaRequired": "O número da licença é obrigatório",
  "numeroLicencaInvalidLength": "O número da licença deve ter 5 caracteres",
  "unexpectedError": "Ocorreu um erro inesperado",
  "nifRequired": "O NIF é obrigatório",
  "nifInvalidLength": "O NIF deve ter 9 dígitos",
  "addressRequired": "O endereço é obrigatório",
  "licenseNumberRequired": "O número da licença é obrigatório",
  "workStartDateRequired": "A data de início de trabalho é obrigatória",
  "dateOfBirthRequired": "A data de nascimento é obrigatória",
  "licenseNumberOperadorPlaceholder": "Nº Licença de Operador",
  "numeroLicencaOperadorRequired": "O número da licença de operador é obrigatório",
  "numeroLicencaOperadorInvalidLength": "O número da licença de operador deve ter até 10 dígitos antes da barra",
  "numeroLicencaOperadorInvalidFormat": "Formato da licença de operador inválido. Use N.../AAAA.",
  "licenseNumberInvalidFormat": "Formato da CMTVDE inválido. Use NNNNNNNN+/AAAA.",
  "countries": {
    "afghanistan": "Afeganistão",
    "albania": "Albânia",
    "algeria": "Argélia",
    "andorra": "Andorra",
    "angola": "Angola",
    "antiguaAndBarbuda": "Antígua e Barbuda",
    "argentina": "Argentina",
    "armenia": "Armênia",
    "australia": "Austrália",
    "austria": "Áustria",
    "azerbaijan": "Azerbaijão",
    "bahamas": "Bahamas",
    "bahrain": "Bahrein",
    "bangladesh": "Bangladesh",
    "barbados": "Barbados",
    "belarus": "Bielorrússia",
    "belgium": "Bélgica",
    "belize": "Belize",
    "benin": "Benin",
    "bhutan": "Butão",
    "bolivia": "Bolívia",
    "bosniaAndHerzegovina": "Bósnia e Herzegovina",
    "botswana": "Botswana",
    "brazil": "Brasil",
    "brunei": "Brunei",
    "bulgaria": "Bulgária",
    "burkinaFaso": "Burkina Faso",
    "burundi": "Burundi",
    "cambodia": "Camboja",
    "cameroon": "Camarões",
    "canada": "Canadá",
    "capeVerde": "Cabo Verde",
    "centralAfricanRepublic": "República Centro-Africana",
    "chad": "Chade",
    "chile": "Chile",
    "china": "China",
    "colombia": "Colômbia",
    "comoros": "Comores",
    "congo": "Congo",
    "costaRica": "Costa Rica",
    "croatia": "Croácia",
    "cuba": "Cuba",
    "cyprus": "Chipre",
    "czechRepublic": "República Tcheca",
    "denmark": "Dinamarca",
    "djibouti": "Djibuti",
    "dominica": "Dominica",
    "dominicanRepublic": "República Dominicana",
    "ecuador": "Equador",
    "egypt": "Egito",
    "elSalvador": "El Salvador",
    "equatorialGuinea": "Guiné Equatorial",
    "eritrea": "Eritreia",
    "estonia": "Estônia",
    "ethiopia": "Etiópia",
    "fiji": "Fiji",
    "finland": "Finlândia",
    "france": "França",
    "gabon": "Gabão",
    "gambia": "Gâmbia",
    "georgia": "Geórgia",
    "germany": "Alemanha",
    "ghana": "Gana",
    "greece": "Grécia",
    "grenada": "Granada",
    "guatemala": "Guatemala",
    "guinea": "Guiné",
    "guineaBissau": "Guiné-Bissau",
    "guyana": "Guiana",
    "haiti": "Haiti",
    "honduras": "Honduras",
    "hongKong": "Hong Kong",
    "hungary": "Hungria",
    "iceland": "Islândia",
    "india": "Índia",
    "indonesia": "Indonésia",
    "iran": "Irã",
    "iraq": "Iraque",
    "ireland": "Irlanda",
    "israel": "Israel",
    "italy": "Itália",
    "jamaica": "Jamaica",
    "japan": "Japão",
    "jordan": "Jordânia",
    "kazakhstan": "Cazaquistão",
    "kenya": "Quênia",
    "kiribati": "Kiribati",
    "koreaSouth": "Coreia do Sul",
    "kuwait": "Kuwait",
    "kyrgyzstan": "Quirguistão",
    "laos": "Laos",
    "latvia": "Letônia",
    "lebanon": "Líbano",
    "lesotho": "Lesoto",
    "liberia": "Libéria",
    "libya": "Líbia",
    "liechtenstein": "Liechtenstein",
    "lithuania": "Lituânia",
    "luxembourg": "Luxemburgo",
    "macau": "Macau",
    "macedonia": "Macedônia",
    "madagascar": "Madagascar",
    "malawi": "Malawi",
    "malaysia": "Malásia",
    "maldives": "Maldivas",
    "mali": "Mali",
    "malta": "Malta",
    "marshallIslands": "Ilhas Marshall",
    "mauritania": "Mauritânia",
    "mauritius": "Maurício",
    "mexico": "México",
    "micronesia": "Micronésia",
    "moldova": "Moldávia",
    "monaco": "Mônaco",
    "mongolia": "Mongólia",
    "montenegro": "Montenegro",
    "morocco": "Marrocos",
    "mozambique": "Moçambique",
    "myanmar": "Myanmar",
    "namibia": "Namíbia",
    "nauru": "Nauru",
    "nepal": "Nepal",
    "netherlands": "Países Baixos",
    "newZealand": "Nova Zelândia",
    "nicaragua": "Nicarágua",
    "niger": "Níger",
    "nigeria": "Nigéria",
    "norway": "Noruega",
    "oman": "Omã",
    "pakistan": "Paquistão",
    "palau": "Palau",
    "palestine": "Palestina",
    "panama": "Panamá",
    "papuaNewGuinea": "Papua-Nova Guiné",
    "paraguay": "Paraguai",
    "peru": "Peru",
    "philippines": "Filipinas",
    "poland": "Polônia",
    "portugal": "Portugal",
    "qatar": "Catar",
    "romania": "Romênia",
    "russia": "Rússia",
    "rwanda": "Ruanda",
    "saudiArabia": "Arábia Saudita",
    "senegal": "Senegal",
    "serbia": "Sérvia",
    "seychelles": "Seicheles",
    "sierraLeone": "Serra Leoa",
    "singapore": "Singapura",
    "slovakia": "Eslováquia",
    "slovenia": "Eslovênia",
    "solomonIslands": "Ilhas Salomão",
    "somalia": "Somália",
    "southAfrica": "África do Sul",
    "southSudan": "Sudão do Sul",
    "spain": "Espanha",
    "sriLanka": "Sri Lanka",
    "sudan": "Sudão",
    "suriname": "Suriname",
    "swaziland": "Suazilândia",
    "sweden": "Suécia",
    "switzerland": "Suíça",
    "syria": "Síria",
    "taiwan": "Taiwan",
    "tajikistan": "Tajiquistão",
    "tanzania": "Tanzânia",
    "thailand": "Tailândia",
    "timorLeste": "Timor-Leste",
    "togo": "Togo",
    "tonga": "Tonga",
    "trinidadAndTobago": "Trinidad e Tobago",
    "tunisia": "Tunísia",
    "turkey": "Turquia",
    "turkmenistan": "Turcomenistão",
    "tuvalu": "Tuvalu",
    "uganda": "Uganda",
    "ukraine": "Ucrânia",
    "unitedArabEmirates": "Emirados Árabes Unidos",
    "unitedKingdom": "Reino Unido",
    "unitedStates": "Estados Unidos",
    "uruguay": "Uruguai",
    "uzbekistan": "Uzbequistão",
    "vanuatu": "Vanuatu",
    "vaticanCity": "Cidade do Vaticano",
    "venezuela": "Venezuela",
    "vietnam": "Vietnã",
    "yemen": "Iêmen",
    "zambia": "Zâmbia",
    "zimbabwe": "Zimbábue"
  },
  "searchCountry": "Pesquisar país",
  "selectCountry": "Selecionar País",
  "phoneNumberInvalid": "O número de telefone deve ter pelo menos 8 dígitos",
  "locationBackgroundPermissionTitle": "Localização (Segundo plano)",
  "locationBackgroundPermissionDescription": "Para continuar rastreando mesmo quando o app estiver fechado",
  "locationBackgroundPermissionImportant": "Importante: Para receber notificações quando estiver parado no mesmo local por muito tempo, você precisa selecionar 'Permitir sempre' nas configurações de localização do seu dispositivo.",
  "lastOdometerReading": "Última Leitura",
  "latestOdometerReading": "Última Leitura",
  "odometerRequired": "A leitura dos KM é obrigatória ao terminar uma sessão",
  "hours": "horas",
  "optional": "Opcional",
  "edited": "Editado",
  "date": "Data",
  "time": "Hora",
  "dateTime": "Data e Hora",
  "observationsRequiredWhenEdited": "Obrigatório quando editado",
  "eventLabels": {
    "session_in": "Início de sessão",
    "session_out": "Fim de sessão",
    "drive_in": "Início de condução",
    "drive_out": "Fim de condução"
  },
  "comingSoon": "Em Breve",
  "ownerRegistrationContact": "Interessado em se registrar como proprietário? Entre em contato em:",
  "userData": {
    "title": "Dados do Usuário",
    "languageTitle": "Configurações de Idioma",
    "currentLanguage": "Idioma Atual",
    "profileTitle": "Meu Perfil",
    "fullName": "Nome Completo",
    "email": "Email",
    "phoneNumber": "Número de Telefone",
    "dateOfBirth": "Data de Nascimento",
    "nif": "NIF",
    "address": "Endereço",
    "licenseType": "Tipo de Licença",
    "licenseNumber": "Número da Licença",
    "workStartDate": "Data de Início de Trabalho",
    "notificationPreferences": "Preferências de Notificação",
    "receiveNotifications": "Receber Notificações",
    "stopTimeThreshold": "Limiar de Tempo de Paragem",
    "distanceThreshold": "Limiar de Distância",
    "vehicleTitle": "Meu Veículo",
    "companyTransferTitle": "Solicitar Transferência de Empresa",
    "currentCompany": "Empresa Atual",
    "requestTransfer": "Solicitar Transferência",
    "editProfile": "Editar Perfil",
    "editVehicle": "Editar Veículo",
    "editVehicleTitle": "Editar Detalhes do Veículo",
    "requestTransferTitle": "Solicitar Transferência de Empresa",
    "newCompanyName": "Nome da Nova Empresa",
    "newCompanyNipc": "NIPC da Nova Empresa",
    "companyEmail": "E-mail da Empresa (Opcional)",
    "companyPhone": "Telefone da Empresa (Opcional)",
    "transferReason": "Motivo da Transferência",
    "submitRequest": "Enviar Solicitação",
    "transferSuccess": "Solicitação de transferência de empresa enviada com sucesso.",
    "transferError": "Falha ao solicitar transferência de empresa.",
    "contactMethodRequired": "Por favor, forneça um e-mail ou número de telefone para a nova empresa.",
    "invalidNipc": "NIPC inválido. Deve ser um número de 9 dígitos começando com 5.",
    "notAvailable": "N/A",
    "noVehicleData": "Nenhuma informação de veículo disponível.",
    "profileUpdateSuccess": "Perfil atualizado com sucesso.",
    "updateError": "Falha ao atualizar perfil.",
    "vehicleLoadError": "Não foi possível carregar os detalhes do veículo.",
    "vehicleUpdateSuccess": "Detalhes do veículo atualizados.",
    "vehicleUpdateError": "Falha ao atualizar detalhes do veículo.",
    "loadError": "Falha ao carregar dados.",
    "languageChanged": "Idioma alterado com sucesso.",
    "languageChangeError": "Falha ao alterar o idioma.",
    "emailChangeSuccess": "Email atualizado. Por favor, verifique seu novo email para confirmar. Você será desconectado.",
    "vehicleIdMissing": "ID do veículo está faltando, não é possível atualizar.",
    "changeEmailTitle": "Alterar Email",
    "changeEmailHint": "Você precisará confirmar seu novo email antes que ele fique ativo.",
    "emailEditHint": "Para alterar seu email, use a seção \"Alterar Email\" abaixo.",
    "newEmail": "Novo email",
    "requestEmailChange": "Solicitar alteração de email",
    "resendConfirmation": "Reenviar email de confirmação",
    "resendInSeconds": "Reenviar em {{seconds}}s",
    "emailChangePendingMessage": "Enviamos um link de confirmação para {{email}}. Clique nele para concluir a alteração do seu email.",
    "emailChangeRequestSuccess": "Se a solicitação for válida, enviamos um email de confirmação para o novo endereço.",
    "emailChangeRateLimited": "Aguarde um momento antes de tentar novamente.",
    "emailChangeError": "Falha ao solicitar a alteração de email.",
    "emailInvalid": "Digite um endereço de email válido."
  },
  "completeDriverProfile": {
    "menu": "Completar Perfil de Motorista",
    "modalTitle": "Tornar-me motorista",
    "boundaryNotice": "Vai usar uma das licenças livres da empresa.",
    "errorTitle": "Não foi possível salvar o perfil",
    "genericError": "Ocorreu um erro ao salvar o perfil. Tente novamente.",
    "networkError": "Não foi possível contactar o servidor. Tente novamente.",
    "submit": "Salvar perfil",
    "becomeDriverSubmit": "Tornar-me motorista"
  },
  "invalidResetLink": "Link de redefinição de senha inválido. Por favor, solicite um novo.",
  "units": {
    "min": "min",
    "m": "m"
  },
  "vehicle": {
    "year": "Ano",
    "licensePlate": "Placa",
    "make": "Marca",
    "model": "Modelo",
    "fuelType": "Combustível",
    "selectFuelType": "Selecionar combustível"
  },
  "fuelTypes": {
    "gasolina": "Gasolina",
    "gasoleo": "Diesel",
    "bifuel": "Bi-combustível",
    "hibrido": "Híbrido",
    "eletrico": "Elétrico"
  },
  "download": {
    "downloadTitle": "Baixar AllDrivers",
    "downloadDescription": "Obtenha acesso antecipado ao aplicativo AllDrivers antes do lançamento na Play Store",
    "feature1": "Rastreamento de Tempo TVDE",
    "feature2": "Rastreamento de Localização",
    "feature3": "Livro de Registro Digital",
    "downloadButton": "Baixar APK",
    "version": "Versão",
    "downloadNote": "Esta é uma versão pré-lançamento. A versão oficial estará disponível em breve na Google Play Store."
  },
  "companyInfo": {
    "menu": "Empresa",
    "title": "Empresa",
    "emailChangeNotice": "Alterar o e-mail da empresa pode exigir verificação."
  },
  "failedToLoadCompany": "Falha ao carregar dados da empresa",
  "failedToUpdateCompany": "Falha ao atualizar a empresa",
  "companyUpdated": "Dados da empresa atualizados com sucesso",
  "emailUpdated": "E-mail atualizado",
  "emailNeedsVerification": "Verifique sua caixa de entrada para confirmar o novo e-mail da empresa.",
  "validation": {
    "required": "Campo obrigatório",
    "invalidEmail": "Email inválido",
    "passwordMinLength": "A senha deve ter no mínimo 8 caracteres"
  },
  "loginInformation": "Informações de Login",
  "identification": "Identificação",
  "next": "Próximo",
  "confirmPasswordRequired": "Por favor, confirme sua senha",
  "passwordsDoNotMatch": "As senhas não coincidem",
  "phoneNumberTooLong": "Número de telefone muito longo",
  "registerTitle": "Cadastrar",
  "emailChangeWarning": "A alteração do seu email requererá verificação. Um email de confirmação será enviado para o novo endereço.",
  "manageDrivers": {
    "title": "Gerenciar Motoristas",
    "search": "Pesquisar",
    "noDriversFound": "Nenhum motorista encontrado.",
    "resend": "Reenviar",
    "resendSuccess": "Convite reenviado com sucesso",
    "resendError": "Erro ao reenviar convite",
    "invitationSent": "Convite enviado com sucesso",
    "status": {
      "active": "ativo",
      "inactive": "inativo",
      "pending": "pendente"
    }
  },
  "manageVehicles": "Gerenciar Veículos",
  "manageLicenses": "Gerenciar Licenças",
  "drivers": {
    "menu": "Motoristas"
  },
  "vehicles": {
    "menu": "Veículos"
  },
  "ownerDashboard": {
    "activeDrivers": "Motoristas Ativos",
    "addDriver": "Adicionar Motorista",
    "addDriverDesc": "Adicionar motorista existente à sua empresa",
    "becomeDriver": "Eu também sou motorista",
    "becomeDriverDesc": "Salvar seu perfil de motorista para onboarding futuro",
    "becomeDriverTitle": "Também quer conduzir?",
    "becomeDriverCta": "Tornar-me motorista",
    "seatsInUseTitle": "Todas as licenças estão em uso",
    "buyLicenseCta": "Comprar licença",
    "completeDriverProfile": "Salvar perfil",
    "totalLicenses": "Total de Licenças",
    "availableLicenses": "Disponíveis",
    "hoursLicenses": "Licenças de Horas",
    "availableHoursLicenses": "Horas Disponíveis",
    "gpsLicenses": "Licenças de GPS",
    "availableGpsLicenses": "GPS Disponíveis",
    "gpsActiveDevices": "Dispositivos GPS Ativos",
    "activeVsLicenses": "Ativos vs Licenças",
    "capacityTitle": "Capacidade corporativa",
    "licensesAndDrivers": "Licenças e motoristas",
    "companyLicensesLabel": "Licenças da empresa",
    "ofLabel": "de",
    "usedLabel": "usadas",
    "activeDriversLabel": "Motoristas ativos",
    "activeDriversUnavailable": "indisponível",
    "totalLabel": "total",
    "companyLabel": "empresa",
    "reservedByInvitationLabel": "Reservadas por convite",
    "payerToConfirmLabel": "Pagador a confirmar",
    "capacityUsedPurchased": "Vagas pagas pela empresa usadas / compradas",
    "capacitySelfPay": "Self-pay",
    "capacityPurchased": "Compradas",
    "capacitySeatsInUse": "Vagas da empresa em uso",
    "capacityNeedsReview": "A confirmar (incluídas acima)",
    "capacityReserved": "Reservadas",
    "capacityAvailable": "Disponíveis",
    "capacitySelfPayAssociations": "Associações self-pay",
    "capacitySelfPayZeroSeats": "Associações self-pay não usam vagas da empresa; consulte a cobertura de cada motorista.",
    "capacityUnavailable": "Capacidade indisponível",
    "activeDriversShort": "Ativos",
    "licensesShort": "Licenças",
    "activatedVsDeactivated": "Ativados vs Desativados",
    "activatedShort": "Ativados",
    "deactivatedShort": "Desativados",
    "gpsDevicesOffline": "Dispositivos Offline >24h",
    "inviteDriver": "Convidar Motorista",
    "inviteDriverDesc": "Enviar convite para novos motoristas",
    "buyLicenses": "Comprar Licenças",
    "buyLicensesDesc": "Comprar licenças adicionais para motoristas",
    "buyHoursLicenses": "Comprar Licenças de Horas",
    "buyHoursLicensesDesc": "Comprar licenças de acompanhamento de horas de motoristas",
    "buyGpsLicenses": "Comprar Licenças de GPS",
    "buyGpsLicensesDesc": "Comprar licenças de rastreamento de dispositivos GPS",
    "companyStats": "Estatísticas da Empresa",
    "currentlyDriving": "Dirigindo Agora",
    "avgDriveTime": "Tempo Médio de Direção",
    "avgDistance": "Distância Média",
    "perDriver": "por condutor",
    "perDay": "por dia",
    "driverLocations": "Localizações dos Condutores",
    "driverLocationsDesc": "Localização em tempo real dos seus condutores",
    "driverStatus": "Status dos Condutores",
    "totalDrivers": "Total de Condutores",
    "inviteSuccess": "Convite enviado com sucesso",
    "choosePlan": "Escolha seu plano",
    "save10Percent": "Economize 10% com o plano anual",
    "14daystrial": "Teste grátis de 7 dias",
    "startTrial": "Iniciar teste de 7 dias",
    "buyNow": "Comprar Agora",
    "trialDaysLeft": "Dias de teste restantes",
    "days": "dias",
    "loadingLicenses": "Carregando informações de licenças...",
    "loadingDashboard": "Carregando dashboard...",
    "checkingLicenses": "Verificando licenças...",
    "chartOnWeb": "Gráfico na web",
    "dailyActiveUsers": "Usuários ativos diários",
    "monthlyActiveUsers": "Usuários ativos mensais",
    "noData": "Sem dados disponíveis",
    "sentAcceptedExpired": "enviados/aceitos/expirados",
    "average": "média",
    "highOdometer": "Maior odômetro",
    "invitations": "Atividade dos convites",
    "invitationSubsetNote": "Os convites são agrupados pela data de criação; o grupo de 7 dias está incluído no de 30 dias.",
    "invitation7Days": "Últimos 7 dias",
    "invitation30Days": "Últimos 30 dias",
    "invitationSent": "Enviados",
    "invitationAccepted": "Aceitos",
    "invitationExpired": "Expirados",
    "invitationUnavailable": "Dados dos convites indisponíveis"
  },
  "common": {
    "cancel": "Cancelar",
    "invite": "Convidar",
    "add": "Adicionar",
    "buy": "Comprar",
    "knowMore": "Saber Mais",
    "all": "Todos",
    "status": "Status",
    "success": "Sucesso",
    "error": "Erro",
    "loading": "Carregando...",
    "now": "Agora",
    "minutesAgo": "{{count}}m atrás",
    "hoursAgo": "{{count}}h atrás",
    "daysAgo": "{{count}}d atrás",
    "retry": "Tentar novamente",
    "remove": "Remover"
  },
  "transfer": {
    "vehicleTitle": "Transferir Veículo",
    "vehicleDescription": "Selecione a empresa para a qual deseja transferir este veículo. Todas as atribuições de motoristas serão removidas.",
    "driverTitle": "Transferir Motorista",
    "driverDescription": "Selecione a empresa para a qual deseja transferir este motorista. Todas as atribuições de veículos serão removidas.",
    "selectCompany": "Por favor, selecione uma empresa de destino",
    "error": "Erro ao transferir",
    "errorLoadingCompanies": "Erro ao carregar empresas",
    "noOtherCompanies": "Você precisa de pelo menos uma outra empresa para transferir.",
    "transferButton": "Transferir",
    "alsoTransferVehicles": "Também transferir {{count}} veículos relacionados",
    "alsoTransferDrivers": "Também transferir {{count}} motoristas relacionados"
  },
  "inviteDriverModal": {
    "title": "Convidar Condutor",
    "optionalFieldsExplanation": "Preencha campos opcionais como nome completo, número de telefone, endereço, número da licença e datas para fornecer mais detalhes. Você pode pular estes campos por enquanto.",
    "addMoreInfo": "Adicionar mais informações",
    "sendButton": "Enviar",
    "activateDialogTitle": "Ativar Condutor",
    "activateDialogMessage": "Este condutor está na sua frota mas inativo. Deseja ativá-lo?",
    "activate": "Ativar",
    "activateError": "Não foi possível ativar este motorista. Tente novamente."
  },
  "inviteForm": {
    "title": "Convidar Condutor",
    "licensePayerTitle": "Quem paga este convite?",
    "licensePayerCompany": "A empresa paga",
    "licensePayerSelf": "O motorista paga",
    "licensePayerRequired": "Selecione quem pagará antes de enviar o convite.",
    "companyLicenseLoading": "Verificando as licenças disponíveis da empresa...",
    "companyLicenseUnavailable": "Não foi possível confirmar a disponibilidade de licenças da empresa. Escolha pagamento pelo motorista ou tente novamente.",
    "companyLicenseError": "Não foi possível verificar as licenças da empresa. Escolha pagamento pelo motorista ou tente novamente.",
    "email": "E-mail",
    "emailRequired": "E-mail é obrigatório",
    "emailInvalid": "Formato de e-mail inválido",
    "fullName": "Nome Completo (Opcional)",
    "fullNameRequired": "Nome completo é obrigatório",
    "phoneNumber": "Número de Telefone (Opcional)",
    "phoneNumberRequired": "Número de telefone é obrigatório",
    "phoneNumberInvalid": "Formato de número de telefone inválido",
    "nif": "NIF (Opcional)",
    "nifRequired": "NIF é obrigatório",
    "nifInvalid": "NIF deve conter 9 dígitos",
    "address": "Endereço (Opcional)",
    "addressRequired": "Endereço é obrigatório",
    "licenseNumber": "Número da CMTVDE (Opcional)",
    "licenseNumberRequired": "Número da CMTVDE é obrigatório",
    "licenseNumberInvalid": "Formato da CMTVDE inválido. Use NNNNNNNN+/AAAA.",
    "workStartDate": "Data de Início do Trabalho (Opcional)",
    "workStartDateRequired": "Data de início do trabalho é obrigatória",
    "dateOfBirth": "Data de Nascimento (Opcional)",
    "dateOfBirthRequired": "Data de nascimento é obrigatória",
    "submit": "Enviar Convite",
    "cancel": "Cancelar",
    "back": "Voltar",
    "optional": "(Opcional)",
    "required": "(Obrigatório)",
    "licenseType": "Tipo de Licença (Opcional)",
    "licenseTypeRequired": "Tipo de licença é obrigatório",
    "licenseExpiry": "Data de Expiração da Licença (Opcional)",
    "licenseExpiryRequired": "Data de expiração da licença é obrigatória",
    "licenseCountry": "País da Licença (Opcional)",
    "licenseCountryRequired": "País da licença é obrigatório",
    "optionalFieldsExplanation": "Você pode adicionar mais informações sobre o condutor (opcional)",
    "addMoreInfo": "Adicionar detalhes do condutor (nome, telefone, endereço, etc.)",
    "noLicensesAvailable": "Nenhuma licença disponível para convidar condutores.",
    "buyLicensesLink": "Clique aqui para comprar mais licenças",
    "expirationInfo": "Este convite expirará em 7 dias."
  },
  "invalidInvitationLink": "Link de convite inválido",
  "invitationNotFound": "Convite não encontrado ou expirado.",
  "acceptInvitation": "Aceitar Convite",
  "invitationTitle": "Convite de {{company}}",
  "invitationLoginMessage": "Faça login para aceitar o convite",
  "invitationRegistrationMessage": "Complete o cadastro para aceitar o convite",
  "invitationExpiredTitle": "Convite expirado",
  "invitationExpiredMessage": "O convite de {{company}} para {{email}} não é mais válido — convites duram 7 dias.",
  "invitationRequestRenewal": "Pedir novo convite",
  "invitationRenewalRequested": "Pedido enviado — {{company}} foi avisada para te enviar um novo convite.",
  "invitationRenewalError": "Não foi possível pedir um novo convite. Tente novamente.",
  "onboardingWelcomeTitle": "Bem-vindo ao nosso aplicativo!",
  "onboardingWelcomeDescription": "Vamos configurar algumas informações importantes antes de começar. Isso nos ajudará a personalizar sua experiência.",
  "continue": "Continuar",
  "finish": "Concluir",
  "retry": "Tentar Novamente",
  "errorAddingVehicle": "Erro ao adicionar veículo.",
  "loadingVehicleInfo": "Carregando informações do veículo...",
  "vehicleDataFound": "Encontramos suas informações de veículo:",
  "edit": "Editar",
  "vehicleFormIntro": "Por favor, forneça informações sobre seu veículo:",
  "licensePlateError": "Formato inválido. Utilize XX-XX-XX (letras e números)",
  "permissionsTitle": "Permissões do Aplicativo",
  "permissionsDescription": "Para oferecer a melhor experiência, precisamos das seguintes permissões:",
  "notificationsPermission": "Notificações",
  "notificationsPermissionMessage": "Para receber notificações, você precisa habilitar esta permissão nas configurações do dispositivo.",
  "notificationsPermissionTitle": "Notificações",
  "notificationsPermissionDescription": "Para receber alertas e informações importantes",
  "locationPermission": "Localização",
  "locationPermissionMessage": "Para usar sua localização atual, você precisa habilitar esta permissão nas configurações do dispositivo.",
  "locationForegroundPermissionTitle": "Localização (Em primeiro plano)",
  "locationForegroundPermissionDescription": "Para mostrar sua localização atual no mapa",
  "locationBackgroundError": "Permissão necessária",
  "locationBackgroundErrorMessage": "Você precisa habilitar a localização em primeiro plano antes de habilitar a localização em segundo plano.",
  "backgroundLocationPermission": "Localização (Segundo plano)",
  "backgroundLocationPermissionMessage": "Para usar sua localização em segundo plano, você precisa habilitar esta permissão nas configurações do dispositivo e selecionar 'Permitir sempre'.",
  "employmentTitle": "Informação de Emprego",
  "loadingEmploymentInfo": "Carregando informações de emprego...",
  "employmentDataFound": "Encontramos suas informações de emprego:",
  "employmentFormIntro": "Por favor, forneça informações sobre seu emprego:",
  "nipcError": "O NIPC deve conter 9 dígitos",
  "companyNipc": "NIPC da Empresa",
  "invitations": "Convites",
  "driverActive": "Condutor já ativo.",
  "driverInactive": "Condutor inativo na frota.",
  "invitePending": "Convite pendente.",
  "buyLicense": {
    "annualSavings": "Economize 10% com o plano anual",
    "title": "Comprar Licenças",
    "description": "Adquirir licenças adicionais para motoristas da sua empresa",
    "currentLicenses": "Licenças Atuais",
    "availableLicenses": "Licenças Disponíveis",
    "activeDrivers": "Motoristas Ativos",
    "selectPlan": "Selecione um plano de assinatura",
    "selectQuantity": "Quantas licenças você precisa?",
    "quantity": "Número de licenças",
    "summary": "Resumo do Pedido",
    "plan": "Plano",
    "licenses": "Licenças",
    "total": "Total",
    "setupFee": "Taxa de instalação",
    "once": "uma vez",
    "monthlyAmount": "Valor mensal",
    "totalFirstInvoice": "Total (1ª fatura)",
    "purchase": "Comprar",
    "processing": "Processando...",
    "errorFetchingPlans": "Erro ao buscar planos de assinatura",
    "noPlanSelected": "Por favor, selecione um plano primeiro",
    "invalidQuantity": "Número de licenças inválido",
    "stripeInitError": "Falha ao inicializar o sistema de pagamento",
    "subscriptionError": "Falha ao criar a assinatura",
    "noData": "Nenhum dado recebido do servidor",
    "noPaymentIntent": "Nenhuma informação de pagamento recebida",
    "purchaseFailed": "Processo de pagamento falhou. Por favor, tente novamente.",
    "portalOpenFailed": "Falha ao abrir o portal de cobrança",
    "paymentCancelled": "Pagamento foi cancelado",
    "webPaymentError": "Falha ao completar o pagamento",
    "pricePerLicense": "Preço por Licença",
    "totalPrice": "Preço Total",
    "paymentMethod": "Forma de Pagamento",
    "creditCard": "Cartão de Crédito",
    "confirmPurchase": "Confirmar Compra",
    "cancel": "Cancelar",
    "success": "Compra Realizada com Sucesso",
    "successMessage": "Suas licenças foram adicionadas à sua conta",
    "error": "Falha na Compra",
    "errorMessage": "Ocorreu um erro ao processar sua compra. Por favor, tente novamente.",
    "insufficientFunds": "Fundos Insuficientes",
    "insufficientFundsMessage": "Sua forma de pagamento não tem fundos suficientes para esta compra.",
    "invalidCard": "Cartão Inválido",
    "invalidCardMessage": "As informações do cartão fornecidas são inválidas. Por favor, verifique e tente novamente.",
    "networkError": "Erro de Rede",
    "networkErrorMessage": "Houve um problema ao conectar ao serviço de pagamento. Por favor, tente novamente.",
    "quantityRequired": "Por favor, selecione o número de licenças a comprar",
    "paymentMethodRequired": "Por favor, selecione uma forma de pagamento",
    "processingPayment": "Processando pagamento...",
    "paymentSuccess": "Pagamento realizado com sucesso!",
    "paymentError": "Falha no pagamento. Por favor, tente novamente.",
    "licenseAdded": "Licenças adicionadas à sua conta",
    "licenseAddedMessage": "Suas novas licenças foram adicionadas à sua conta com sucesso.",
    "refreshAccount": "Atualizando sua conta...",
    "refreshError": "Erro ao atualizar a conta. Por favor, atualize a página manualmente.",
    "purchaseSuccessUpdating": "Compra de licença realizada com sucesso! Atualizando sua conta...",
    "purchaseSuccessUpdated": "Compra de licença realizada com sucesso! Sua conta foi atualizada.",
    "purchaseSuccessRefreshError": "Compra de licença realizada com sucesso, mas houve um erro ao atualizar sua conta. Por favor, atualize a página.",
    "manageInStripe": "Gerenciar no Stripe",
    "pay": "Pagar Agora"
  },
  "interval": {
    "month": "mês",
    "year": "ano"
  },
  "alerts": {
    "movementDetected": "Você está se movendo mas não está em modo de condução. Por favor, inicie o modo de condução.",
    "stationaryDetected": "Você está parado há algum tempo. Considere parar o modo de condução.",
    "reopenAppBeforeStartingTracking": "Reabra o app antes de iniciar a condução ou o rastreamento da sessão.",
    "locationPermissionDenied": "Permissão de localização não concedida. Clique para tentar novamente.",
    "locationPermissionRequired": "Permissão de Localização Necessária",
    "locationPermissionRequiredMessage": "O aplicativo precisa de acesso à sua localização para funcionar corretamente. Por favor, conceda a permissão de localização.",
    "locationPermissionRetryMessage": "Se você acabou de alterar as permissões de localização nas configurações do seu navegador, por favor, atualize a página para continuar.",
    "locationSettingsInvalid": "Localização Indisponível",
    "locationSettingsInvalidMessage": "Não foi possível obter sua localização. Verifique se o GPS está ativado e se o modo de localização está em alta precisão.",
    "locationTrackingDegraded": "O rastreamento automático da localização está temporariamente indisponível. Sua sessão de trabalho continua disponível.",
    "openDeviceSettings": "Abrir Configurações",
    "locationSettingsManualFallback": "Não foi possível obter sua localização. Ative o GPS nas configurações ou insira sua localização manualmente.",
    "tryAgain": "Tentar Novamente",
    "refreshPage": "Atualizar Página",
    "alert": "Alerta",
    "confirm": "Confirmar"
  },
  "notificationsTitle": "Notificações",
  "notificationsDescription": "Para receber alertas e informações importantes",
  "foregroundLocationDescription": "Para mostrar sua localização atual no mapa",
  "backgroundLocationDescription": "Para continuar rastreando mesmo quando o app estiver fechado",
  "locationRequiredGeneric": "A localização é obrigatória. A sua localização não foi partilhada.",
  "manualLocationPrompt": "Em alternativa, insira a sua localização abaixo (endereço, cidade ou local).",
  "manualLocationLabel": "A sua localização (endereço)",
  "locationNotFound": "Não foi possível encontrar essa localização.",
  "tryAllowLocation": "Tentar permitir localização novamente",
  "errors": {
    "errorLoadingData": "Erro ao carregar dados",
    "errorLoadingDataMessage": "Houve um problema ao carregar seus dados. Por favor, tente novamente.",
    "reloadPage": "Recarregar Página"
  },
  "purchase": {
    "success": {
      "title": "🎉 Compra Realizada com Sucesso!",
      "messageNew": "Suas licenças GPS foram compradas com sucesso!",
      "messageUpdated": "Suas licenças GPS foram atualizadas com sucesso!",
      "licenses": "Licenças Compradas:",
      "gpsLicenses": "Licenças GPS",
      "ready": "Você pode agora atribuir estas licenças aos seus motoristas e veículos.",
      "close": "Entendi!"
    }
  },
  "licenseType": {
    "selectType": "Selecionar tipo...",
    "tvde": "Operador TVDE",
    "taxi": "Táxi",
    "lightGoods": "Veículos leves de mercadorias",
    "roadTransport": "Transporte Rodoviário (Sem Tacógrafo)",
    "other": "Outro"
  },
  "languages": {
    "english": "🇬🇧 English",
    "portuguese": "🇵🇹 Português",
    "portugueseBR": "🇧🇷 Português (BR)"
  },
  "register": {
    "choiceTitle": "Cadastrar",
    "driverButton": "Condutor",
    "ownerButton": "Proprietário de Frota",
    "registerTitle": "Cadastrar",
    "registerDriverTitle": "Registo de Condutor",
    "registerOwnerTitle": "Registar como Proprietário de Frota",
    "next": "Próximo",
    "back": "Voltar",
    "submitButton": "Enviar",
    "loginInformation": "Informações de Login",
    "identification": "Identificação",
    "driverDetails": "Detalhes do Condutor",
    "companyInformation": "Informação da Empresa",
    "registrationSuccessTitle": "Registado com sucesso!",
    "registrationSuccessMessage": "Confirme o seu email para completar o registo.",
    "okButton": "OK"
  },
  "changePaymentMethod": {
    "title": "Atualizar Método de Pagamento",
    "description": "Você será solicitado a inserir os detalhes do seu novo método de pagamento.",
    "continue": "Continuar",
    "update": "Atualizar Método de Pagamento",
    "processing": "Processando...",
    "success": "Sucesso",
    "error": "Erro",
    "paymentMethodUpdated": "Método de pagamento atualizado com sucesso",
    "paymentMethodError": "Falha ao atualizar método de pagamento",
    "paymentCancelled": "Pagamento cancelado",
    "webPaymentError": "Falha ao concluir pagamento"
  },
  "errorCancelingInvitation": "Erro ao cancelar convite",
  "errorFetchingInvitations": "Erro ao carregar convites",
  "errorResendingInvitation": "Erro ao reenviar convite",
  "expired": "Expirado",
  "expiresToday": "Expira hoje",
  "expiresTomorrow": "Expira amanhã",
  "invitationsPending": "pendente(s)",
  "loadingInvitations": "Carregando convites...",
  "noInvitations": "Sem convites pendentes.",
  "resend": "Reenviar",
  "assign": "Atribuir",
  "completePurchase": "Concluir compra",
  "continueToPayment": "Continuar para pagamento",
  "continueToTrial": "Iniciar período de teste",
  "errorOpeningPortal": "Erro ao abrir portal de pagamento",
  "paymentDescription": "Você será redirecionado para a nossa página de pagamento seguro para concluir a compra.",
  "paymentError": "Ocorreu um erro. Por favor, tente novamente.",
  "paymentModalTitle": "Concluir compra",
  "trialDescription": "Você será redirecionado para a nossa página de pagamento seguro para iniciar o período de teste.",
  "statusLabels": {
    "pending": "Pendente"
  },
  "companyPhone": "Telefone da Empresa (Opcional)",
  "myVehicles": {
    "menu": "Meus Veículos",
    "title": "Meus Veículos",
    "addVehicle": "Adicionar Veículo",
    "addFirstVehicle": "Adicionar Meu Primeiro Veículo",
    "emptyTitle": "Você ainda não tem veículos",
    "emptyMessage": "Adicione seu primeiro veículo para começar a registrar suas viagens",
    "noDetails": "Sem detalhes",
    "tooltipTitle": "Sobre múltiplos veículos",
    "tooltipMessage": "A maioria dos motoristas usa apenas um veículo, mas você pode adicionar mais se necessário",
    "unassignTitle": "Remover Veículo",
    "confirmUnassign": "Tem certeza que deseja remover o veículo {{plate}} de sua frota?",
    "editVehicleInfo": "Editar Veículo"
  },
  "vehicleModal": {
    "registrationNumberImmutable": "A matrícula não pode ser alterada. Para uma matrícula diferente, crie um novo veículo."
  },
  "vehicleSelection": {
    "title": "Selecione o Veículo",
    "subtitle": "Escolha o veículo que você usará nesta sessão de trabalho",
    "confirm": "Confirmar"
  },
  "notifications.stopDriveButton": "Parar de Conduzir",
  "notifications.cancelButton": "Cancelar",
  "notifications.activeTracking": "Rastreamento Ativo",
  "notifications.locationBeingMonitored": "Sua localização está sendo monitorada.",
  "notifications.attention": "Atenção",
  "notifications.movementDetectedBody": "Você está se movendo, mas não está em modo de condução. Por favor, inicie o modo de condução.",
  "notifications.stationaryDetectedBody": "Você está parado há mais de {{minutes}} minutos. Considere parar de conduzir.",
  "notifications.drivingStatus": "Status de Condução",
  "notifications.driving": "Dirigindo",
  "notifications.activeSession": "Sessão Ativa",
  "notifications.tapToChange": "Toque para alterar o status de condução",
  "notifications.startDrivingButton": "Iniciar Condução",
  "notifications.stopDrivingButton": "Parar de Conduzir",
  "notifications": {
    "activeSession": "Sessão Ativa",
    "activeTracking": "Rastreamento Ativo",
    "attention": "Atenção",
    "cancelButton": "Cancelar",
    "driving": "Dirigindo",
    "drivingStatus": "Status de Condução",
    "locationBeingMonitored": "Sua localização está sendo monitorada.",
    "movementDetectedBody": "Você está se movendo, mas não está em modo de condução. Por favor, inicie o modo de condução.",
    "startDrivingButton": "Iniciar Condução",
    "stationaryDetectedBody": "Você está parado há mais de {{minutes}} minutos. Considere parar de conduzir.",
    "stopDriveButton": "Parar de Conduzir",
    "stopDrivingButton": "Parar de Conduzir",
    "tapToChange": "Toque para alterar o status de condução"
  },
  "invitationRecipient": "Conta que aceita: {{email}}",
  "invitationPayerCompany": "Pagador: empresa",
  "invitationPayerSelf": "Pagador: próprio",
  "invitationPayerUnknown": "Pagador não confirmado. Peça esclarecimento à empresa antes de aceitar.",
  "invitationCompanyConsent": "Ao aceitar, a empresa de trabalho passa a ser a indicada neste convite. A sessão já aberta e o histórico mantêm a atribuição original.",
  "invitationConfirm": "Aceitar convite",
  "invitationIdentityChanged": "A conta ou as condições do convite mudaram. Abra o convite novamente para confirmar.",
  "invitationAcceptanceFailed": "Não foi possível aceitar o convite. Tente novamente ou contate o suporte.",
  "drivingLimit": {
    "warningTitle": "Limite de direção se aproximando",
    "warningBody": "Faltam {{minutes}} min para atingir {{hours}} h de direção nas últimas 24 h, se continuar dirigindo.",
    "reachedTitle": "Limite de direção atingido",
    "reachedBody": "Você atingiu {{hours}} h de direção nas últimas 24 h. Pare com segurança e faça uma pausa.",
    "noticeWarning": "Restam {{remaining}} até o limite de {{hours}} h de direção em 24 h.",
    "noticeReached": "Limite de {{hours}} h de direção em 24 h atingido.",
    "noticeReachedUntil": "Limite de {{hours}} h de direção em 24 h atingido. Você volta a ficar abaixo do limite às {{time}}.",
    "day": {
      "warningBody": "Faltam {{minutes}} min para atingir {{hours}} h de direção hoje, se continuar dirigindo.",
      "reachedBody": "Você atingiu {{hours}} h de direção hoje. Pare com segurança e faça uma pausa.",
      "noticeWarning": "Restam {{remaining}} até o limite de {{hours}} h de direção hoje.",
      "noticeReached": "Limite de {{hours}} h de direção hoje atingido. A contagem recomeça às {{time}}."
    }
  },
  "workTime": {
    "states": {
      "resting": "Sessão inativa",
      "available": "Sessão ativa",
      "driving": "Dirigindo"
    },
    "since": "desde {{time}}",
    "timerA11y": "{{state}} há {{duration}}",
    "limits": {
      "title": "Limites de direção",
      "subtitle": "Limites de referência: são só avisos e nada é bloqueado.",
      "viewAll": "Ver limites",
      "close": "Fechar",
      "usedOf": "{{used}} de {{limit}}",
      "remaining": "Restam {{remaining}}",
      "noData": "Sem registro recente",
      "rolling24h": {
        "title": "Direção nas últimas 24 h",
        "short": "24 h"
      },
      "calendarDay": {
        "title": "Direção hoje (00:00–24:00)",
        "short": "Hoje",
        "lawNote": "A lei conta as 10 h em 24 h seguidas."
      },
      "week": {
        "title": "Direção esta semana",
        "short": "Semana",
        "range": "segunda a domingo",
        "reached": "Limite semanal atingido. Mais direção passa de 60 h."
      },
      "fourMonth": {
        "title": "Média de direção em 4 meses",
        "short": "4 meses",
        "value": "{{avg}} h por semana (limite {{limit}} h)",
        "available": "Para ficar abaixo de {{limit}} h de média: até {{hours}} h de direção nesta semana.",
        "window": "Média das últimas {{weeks}} semanas, incluindo esta.",
        "over": "Média acima de {{limit}} h. Dirija menos horas nas próximas semanas.",
        "partial": "Você ainda não tem 17 semanas de registros: as semanas sem registro contam como 0 h.",
        "above": "Acima do limite",
        "summaryValue": "média {{avg}} h / {{limit}} h"
      },
      "levels": {
        "ok": "Dentro do limite",
        "warning": "Atenção",
        "critical": "Quase no limite",
        "reached": "Limite atingido",
        "unknown": "Sem registro"
      },
      "weekWarning": "{{used}} de direção esta semana. Limite: {{limit}}.",
      "fourMonthWarning": "Média de direção em 4 meses: {{avg}} h por semana. Limite: {{limit}} h.",
      "howWeCount": {
        "title": "Como contamos",
        "driving": "Só conta o tempo em «Dirigindo», em todas as plataformas.",
        "periods": "24 h: as últimas 24 horas. Semana: de segunda a domingo. 4 meses: média por semana das últimas 17 semanas.",
        "notCounted": "Sessão ativa sem dirigir e sessão encerrada não contam. Tempo sem registro nunca conta como descanso.",
        "disclaimer": "São limites de referência, só para avisar. Mostram o tempo de direção registrado no app e não são um registro oficial de horas.",
        "periodsDay": "Hoje: das 00:00 às 24:00; uma viagem que passe da meia-noite conta em cada dia a sua parte. Semana: de segunda a domingo. 4 meses: média por semana das últimas 17 semanas.",
        "owner": "A empresa sempre vê a contagem em 24 h seguidas."
      },
      "summaryValue": "{{used}} / {{limit}}"
    },
    "notifications": {
      "ongoingBody": "Desde as {{time}}.",
      "weekWarningTitle": "Direção na semana: {{used}} h de {{limit}} h",
      "weekWarningBody": "Restam {{remaining}} h de direção até o limite semanal.",
      "fourMonthWarningTitle": "Média de direção em 4 meses perto do limite",
      "fourMonthWarningBody": "Média de {{avg}} h por semana. Limite: {{limit}} h."
    },
    "mode": {
      "sectionTitle": "Limites de direção",
      "itemTitle": "Contagem do limite de 10 h",
      "intro": "Escolha como o app conta as 10 h de direção. O aviso chega 60 min antes e às 10 h. É só um aviso: nunca bloqueia o app.",
      "recommended": "Recomendado",
      "rolling": {
        "title": "24 h seguidas",
        "description": "Soma a direção das últimas 24 horas, a qualquer hora do dia."
      },
      "calendarDay": {
        "title": "Por dia (00:00–24:00)",
        "description": "Soma só a direção de hoje e recomeça às 00:00. Uma viagem que passe da meia-noite conta em cada dia a sua parte."
      },
      "nothingChanges": "Mudar não apaga nem altera registros. A semana (60 h), a média de 4 meses e os relatórios PDF continuam iguais.",
      "saved": "Contagem salva: {{mode}}.",
      "saveError": "Não foi possível salvar. A contagem continua: {{mode}}."
    }
  },
  "mapLoading": {
    "title": "Preparando seu mapa ao vivo",
    "subtitle": "Carregando a localização e os controles antes de a rota aparecer.",
    "loading": "Carregando o mapa…",
    "errorTitle": "Não foi possível carregar o mapa",
    "errorMessage": "Verifique sua conexão e tente novamente. Os controles da sessão continuam funcionando.",
    "retry": "Tentar novamente"
  }
}
